/*
 * @Author: dumin
 * @Date: 2021-09-24 16:48:09
 * @LastEditTime: 2021-09-24 18:03:05
 * @Description: 判断是否为 pc 端 还是移动端
 */

const browser = function(){
    return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
}

export default browser